<template>
  <v-btn
    fab
    outlined
    color="white"
    class="text-h5 ma-4"
    v-text="value"
    @click="$emit('click', String(value))"
  />
</template>

<script>
  export default {
    props: {
      value: {
        required: true,
        type: [String, Number],
      },
    },
  }
</script>
